import React from "react";
import { Heading, VStack } from "@chakra-ui/react";
import SkillsBox from "./SkillsBox";
import SkillsCard from "./SkillsCard";

const Automation = () => {
  return (
    <div id="automation">
      <Heading size={"md"} className="my-6 uppercase">
        Others
      </Heading>
      <VStack>
        <SkillsBox>
          <SkillsCard
            title={"PostMan"}
            text={
              "Postman is an application used for API testing. It is an HTTP client that tests HTTP requests, utilizing a graphical user interface"
            }
            cat={"Api Tester"}
          />
        </SkillsBox>
      </VStack>
    </div>
  );
};

export default Automation;
